import React, { FC } from 'react';
import { Link } from 'react-router-dom';

import styles from '../AccountDetails.module.scss';

type Props = {
  title: string;
};

export const AccountDetailsBreadcrumbs: FC<Props> = ({ title }) => (
  <div className={styles.breadcrumbs}>
    <Link to="../.." relative="path" className={styles.breadcrumbLink}>
      Главная
    </Link>
    <span className={styles.breadcrumbSeparator}>/</span>
    <span className={styles.breadcrumbCurrent}>{title}</span>
  </div>
);
